import React from 'react';

import ReactModal from 'react-modal';
import Aux from '../../../hoc/ReactAux/ReactAux';
import timeUtils from 'utils/time';
import { orderPlacedMessage } from 'utils/orderConfirmation';
import './modalReceiptTest.scss';

const customStyles = {
  content: {
    background: 'none',
    border: 'none',
    height: '100%',
    left: '0',
    right: '0',
    top: '0',
    bottom: '0',
    overflowY: 'scroll',
  },
  overlay: {
    position: 'fixed',
    zIndex: '9999999',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
};

const Product = props => {
  return (
    <div className="bloco">
      <div className="wrapper">
        <strong className="left">{props.name}</strong>
        <strong className="right">{props.price}</strong>
      </div>
      <span>{props.description}</span>
    </div>
  );
};

const ResumeLine = props => {
  const classes = !!props.bold ? 'wrapper total' : 'wrapper';
  return props.showResume ? (
    <div className={classes}>
      <div className="left">{props.name}</div>
      <div className="right">{props.value}</div>
    </div>
  ) : null;
};

const CustomerDetails = ({
  firstName,
  lastName,
  businessName,
  isCollection,
  address,
}) => {
  let customerName = `${firstName} ${lastName}`;
  return (
    <div className="head">
      <strong>
        {isCollection
          ? `Collection by ${customerName}`
          : `Delivery to ${customerName}, ${businessName}`}
      </strong>
    </div>
  );
};

const OrderDateDetails = ({ cart, isCollection }) => {
  return (
    <Aux>
      {!!cart && !!cart.orderDeliveryDate && isCollection
        ? `Time for collection : ${timeUtils.formatDateToDateTimeAmPm(
            cart.orderDeliveryDate
          )}`
        : `Date: ${timeUtils.formatDateToDateTimeAmPm(cart.orderDeliveryDate)}`}
    </Aux>
  );
};

const modalReceiptVoucher = props => {
  if (!props.showModal) {
    return null;
  }

  const publicOrderNumber = props.data.cart.publicOrderNumber;
  const orderReference = publicOrderNumber
    ? `Order ${publicOrderNumber}`
    : 'Order details';

  const renderProduct = (item, currency, index) => {
    return (
      <Product
        key={index}
        name={item.name}
        price={`${currency} ${Number(item.price).toFixed(2)}`}
        description={`${item.description || ''} ${item.calory || ''}`}
      />
    );
  };

  return (
    <Aux>
      <ReactModal
        isOpen={true}
        style={customStyles}
        onRequestClose={props.closeModal}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        contentLabel="Example Modal"
      >
        <div id="lb-receipt" className="lb-geral lb-receipt_">
          <div className="modal-content modal-content-receipt" tabIndex={0}>
            <button
              type="button"
              className="bt-close mfp-close lb-fechar fa fa-times"
              onClick={props.closeModal}
            />
            <div className="check-mark">
              <span className="fa fa-check-circle lt-success-tick" aria-hidden="true" />
            </div>
            <div className="lb-content">
              <span className="order">
                <strong>{orderPlacedMessage(publicOrderNumber)}</strong>
              </span>
              <div className="purchase">
                <h3>Receipt</h3>
                <strong className="thank-you">
                  Thank you for your purchase,{' '}
                  {props.data.userDetails.firstName} :)
                </strong>
                <span className="order-date">
                  {orderReference}
                  <br />
                  <OrderDateDetails
                    cart={props.data.cart}
                    isCollection={props.data.forCollection === 'Y'}
                  />
                </span>
                <div className="delivery">
                  <CustomerDetails
                    businessName={props.data.userDetails.businessName}
                    firstName={props.data.userDetails.firstName}
                    lastName={props.data.userDetails.lastName}
                    isCollection={props.data.forCollection === 'Y'}
                  />
                  <div className="content">
                    {props.data.cart.products.map((product, index) =>
                      renderProduct(product, props.data.currency, index)
                    )}
                  </div>
                  <div className="foot">
                    <ResumeLine
                      showResume={true}
                      name="Subtotal"
                      value={`${props.data.currency} ${Number(
                        props.data.subtotal
                      ).toFixed(2)}`}
                    />
                    {!!props.data.surcharge && (
                      <ResumeLine
                        showResume={true}
                        name="Surcharge"
                        value={`${props.data.currency} ${Number(
                          props.data.surcharge
                        ).toFixed(2)}`}
                      />
                    )}
                    <ResumeLine
                      showResume={true}
                      name="Total"
                      value={`${props.data.currency} ${Number(
                        props.data.total
                      ).toFixed(2)}`}
                      bold={true}
                    />
                  </div>
                </div>
              </div>
              <a onClick={props.closeModal} className="bt">
                Got it
              </a>
            </div>
          </div>
        </div>
      </ReactModal>
    </Aux>
  );
};

export default modalReceiptVoucher;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalReceiptVoucher.js